import { useEffect, useRef } from "react";
import './App.css';
import RoutesComponent from './Routes/routes';
import 'bootstrap/dist/css/bootstrap.min.css';
import { IdleTimerProvider } from "react-idle-timer";
import { CommonAxiosGet, CommonAxiosPost } from "./Components/CommonUtils/CommonAxios/CommonAxios";
import { config } from "./Components/CommonUtils/CommonUrl/CommonUrls";
 
function App() {
 
  const isLoggingOut = useRef(false);
 
  const handleOnIdle = () => {
    if (!isLoggingOut.current) {
      isLoggingOut.current = true;
      saveLoginTracker();
    }
  };
 
  function KillToken() {
    let refreshToken = JSON.parse(localStorage.getItem("refresh_token"));
    const payload = {
      refresh_token: refreshToken
    };
    CommonAxiosPost("killtoken", payload).then((response) => {
 
    });
  };
 
 
 
  const saveLoginTracker = () => {
    CommonAxiosGet("v1/logout").then((res) => {
      KillToken();
      localStorage.clear();
      window.location.href = config.url.UI_URL;
    })
  }
 
  useEffect(() => {
 
    if (localStorage.getItem('token') === null || localStorage.getItem('token') === undefined) {
      localStorage.clear();
    }
 
    const handleContextMenu = (e) => {
      e.preventDefault();
      alert("You are not allowed to perform this action!");
    };
 
    const handleKeyDown = (e) => {
      if (
        e.keyCode === 123 || // F12
        (e.ctrlKey && e.shiftKey && e.keyCode === 'I'.charCodeAt(0)) || // Ctrl+Shift+I
        (e.ctrlKey && e.shiftKey && e.keyCode === 'C'.charCodeAt(0)) || // Ctrl+Shift+C
        (e.ctrlKey && e.shiftKey && e.keyCode === 'J'.charCodeAt(0)) || // Ctrl+Shift+J
        (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0)) // Ctrl+U
      ) {
        e.preventDefault();
        alert("You are not allowed to perform this action!");
        return false;
      }
    };
 
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
 
 
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
 
  return (
    <>
      <IdleTimerProvider
        timeout={1800000}
        onIdle={handleOnIdle} >
        <div className="main_section"></div>
        <RoutesComponent />
      </IdleTimerProvider>

    </>
  );
}
 
export default App;



// import React from 'react';
// import './App.css';
// import Footer from './Components/Footer/Footer';
// import RoutesComponent from './Routes/routes';
// import { FaFile } from "react-icons/fa";
// function App() {
//   if(window !== window.top){
//     return(
//       <React.Fragment>
//       <div className="container-fluid pt-8" >
//       <div className='page-hero d-flex align-items-center justify-content-center'>
//      <p>  <FaFile fontSize={20} /> This site is Refused to connect</p>
//      </div>
//       </div>
//       </React.Fragment>
//       )
//   }
//   else if(window === window.top) {
//     return (
//       <React.Fragment>
//       <RoutesComponent></RoutesComponent>
//         <Footer />
//       </React.Fragment>
     
//     );
//   }
  
 
// }

// export default App;